import {Component, Inject, ViewChild} from '@angular/core';
import {Platform, Nav, ToastController, IonicApp, MenuController} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {LoopBackConfig, CompanyApi} from '../sdk/';
import {LoopBackAuth} from "../sdk";
import {ServerProvider} from '../providers/server-provider';
import {UsersApi} from '../sdk';
import {IUsers} from '../models/iUsers';
import {HttpErrorResponse} from '@angular/common/http';
import {_throw} from 'rxjs/observable/throw';
import {TranslateService} from '@ngx-translate/core';
import {LoadingComponent} from '../components/loadingComponent';
import {AutoupdateProvider} from '../providers/autoupdate-provider';
import {EnvVariables} from "../../envioronment-variables/environment-variables.token";
import {StorageCacheProvider} from "../providers/storage-cache-provider";


@Component({
    templateUrl: 'app.html'
})
export class MyApp {

    @ViewChild(Nav) nav: Nav;

    //gurda datos del usuario actual
    public userLogin: IUsers;

    // guarda el hostId al que se conecta el servidor
    private hostId: string;

    //Controla si el boton back de android se ha pulsado o no
    private isBackButtonPressed: boolean;

    public showSelectorChangeCompany: boolean = false;

    constructor(
        private ionicApp: IonicApp,
        private platform: Platform,
        private statusBar: StatusBar,
        private toastCtrl: ToastController,
        private menu: MenuController,
        public loading: LoadingComponent,
        public authService: LoopBackAuth,
        public companyServices: CompanyApi,
        public usersServices: UsersApi,
        private translate: TranslateService,
        private autoupdate: AutoupdateProvider,
        private storageCache: StorageCacheProvider,
        @Inject(EnvVariables) public envVariables
    ) {

        //idioma por defecto - sistema de traducciones
        this.translate.setDefaultLang('es');
        this.translate.use('es');

        this.isBackButtonPressed = false;
        this.showSelectorChangeCompany = false;

        ServerProvider.init(this);

        //inicializar loopback
        LoopBackConfig.setBaseURL(this.envVariables.loopbackBaseUrl);
        LoopBackConfig.setApiVersion(this.envVariables.loopbackApiVersion);

        // nombre del host al que se realiza el login
        this.getDefaultHostId().then(hostId => {
            this.setHostId(hostId);
        })

        platform.ready().then(() => {

            authService.setRememberMe(true);

            //status bar
            if (this.platform.is('android')) {
                this.statusBar.styleBlackOpaque();
            }

            //cargar datos de mi usuario
            this.getLoadMyUser();

            //evento de back
            this.onBackButtonAction();

            //comprobar version de la app
            this.autoupdate.ckeckMinVersionApp();

        });

    }

    public setHostId(hostId: string) {
        this.hostId = hostId;
        this.storageCache.setStorageData(StorageCacheProvider.STORAGE_KEYS.DEFAULT_HOST_ID, hostId);
    }

    public getHostId(): string {
        return this.hostId;
    }

    public async getDefaultHostId() {
        const hostId = await this.storageCache.getStorageData(StorageCacheProvider.STORAGE_KEYS.DEFAULT_HOST_ID);
        if (hostId != null) {
            const searchHost = this.envVariables.hosts.find(item => item.id == hostId);
            if (searchHost != null) {
                return searchHost.id;
            }
        }
        return this.envVariables.hosts[0].id;
    }

    /**
     * Carga los datos de mi usuario
     */
    public getLoadMyUser() {

        this.showSelectorChangeCompany = false;

        //obtener datos del oauth
        let authUser = this.authService.getCurrentUserData();
        let authToken = this.authService.getAccessTokenId();

        //comprobar que exista token y usuario
        if (!authToken || !authUser || !authUser.name) {
            //cerra session si esta abierta e ir a la ventana de login

            if (!this.nav || !this.nav._views || !this.nav._views[0] || !this.nav._views[0].component || this.nav._views[0].component.name != "LoginPage") {
                this.logout();
            }

            return _throw(new HttpErrorResponse({status: 401}));
        }

        ServerProvider.find(this.usersServices, {
            fields: IUsers.FIELDS,
            include: IUsers.FILTER_INCLUDE,
            where: {
                login: authUser.name
            }
        }).subscribe(users => {
            if (users && users.length > 0) {
                //creamos usuario
                let currentUser: any = users[0];
                this.userLogin = new IUsers(currentUser);

                console.log("====USER====", this.userLogin);

                //cargar compañias
                this.getLoadMyCompanies();

            } else {
                //no se devolvieron usuarios en el login
                return _throw(new HttpErrorResponse({status: 401}));
            }
        });
    }

    /**
     * Carga mis compañias
     */
    public getLoadMyCompanies() {

        if (this.companyServices) {
            ServerProvider.find(this.companyServices, {'fields': ['id', 'active', 'name']}, true).subscribe(allCompanies => {

                //guardar en userLogin mis compañias
                this.userLogin.companies = allCompanies;

                //guardar en userLogin mi compañia seleccionada
                for (let i = 0; i < this.userLogin.companies.length; i++) {
                    //buscar mi empresa seleccionada
                    let tempCompany = this.userLogin.companies[i];
                    if (tempCompany && tempCompany.id == this.userLogin.company_id) {
                        //empresa seleccionada
                        this.userLogin.myCompany = tempCompany;
                    }
                }

                //activar el selector de cambio de compañia
                this.showSelectorChangeCompany = true;

                //control de gestion de URLs
                this.onNavDefault();
            });
        }

    }

    /**
     * Gestiona la ruta actual
     */
    public onNavDefault() {
        if (this.nav) {
            if (!this.nav._views || this.nav._views.length == 0) {
                //redireccionar al partnerlist
                this.nav.setRoot('HomogenizationOrderListPage');
            } else if (this.nav._views[0].component.name) {
                this.nav.setRoot(this.nav._views[0].component.name);
            } else {
                this.nav.setRoot('HomogenizationOrderListPage');
            }

        } else {
            //wait
            setTimeout(() => {
                this.onNavDefault();
            }, 1000);
        }
    }


    /**
     * Cambia la compañia seleccionada por defecto
     *
     * @param company_id id de mi compañia
     */
    public changeMyCompany(company_id) {
        console.log("changeMyCompany", company_id);
        if (company_id && company_id > 0 && this.userLogin.company_id != company_id) {

            //cambiamos id de usuario
            this.userLogin.company_id = company_id;

            this.usersServices.change_user_company(this.userLogin.id, company_id, ServerProvider.getCustomHeaders).subscribe(success => {
                //usuario cambiado
                console.log("ok changeCompany", success);
                if (success) {
                    window.location.reload();
                } else {
                    throw (new Error("COMPANY-CHANGE"));
                }

            }, error => {
                console.log("error cambiar compañia", error);

                throw (new Error("COMPANY-CHANGE"));
            });

        }
    }


    /**
     * Evento de click boton back del movil
     */
    private onBackButtonAction() {

        //Button back mobile
        this.platform.registerBackButtonAction(() => {

            if (this.isBackButtonPressed) {
                //pulsado 2 veces para cerrar
                this.platform.exitApp();
            }

            //cierra algun popup, o modal abierto
            let activePortal = this.ionicApp._loadingPortal.getActive() ||
                this.ionicApp._modalPortal.getActive() ||
                this.ionicApp._toastPortal.getActive() ||
                this.ionicApp._overlayPortal.getActive();

            if (activePortal) {
                activePortal.dismiss();
                return;
            }

            //vuelve a la ventana apilada anterior
            if (this.nav.canGoBack()) {
                this.nav.pop()
                return;
            }

            //pulsar 2 veces para cerrar boton
            if (!this.isBackButtonPressed) {
                this.isBackButtonPressed = true;

                //mostrar toast
                this.toastCtrl.create({message: "Pulsa otra vez para cerrar la aplicación", duration: 1000}).present();

                setTimeout(() => this.isBackButtonPressed = false, 2000);
                return;
            }

        });

    }

    /////////////// MENUS //////////////////

    /**
     * Ir a la página de FAQ
     */
    public goToFaq() {
        this.nav.setRoot('FaqPage');
    }

    public goToHomogenization() {
        this.nav.setRoot('HomogenizationOrderListPage')
    }

    public goToProductionOrders() {
        this.nav.setRoot('ProductionOrderListPage')
    }

    public goToManufacturingProductionOrders() {
        this.nav.setRoot('ManufacturingProductionOrderListPage')
    }

    /**
     * Logout
     */
    public logout() {
        //cerrar menu
        this.menu.close();

        //mensaje de cerrando session
        this.loading.create({content: 'Cerrando sesión de usuario'});

        //timeout para enviar bug en android
        setTimeout(() => {
            //ocultar modal
            this.loading.dismiss();

            //cerrar session
            this.authService.clear();
            this.nav.setRoot('LoginPage');
        }, 1000);
    }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts